import { createStyles } from 'antd-style';

import {
  INPUT_BASE_HEIGHT,
  INPUT_BOX_SHADOW,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../../theme';

export const useDateRangePickerStyles = createStyles(({ token }) => ({
  inputLike: {
    '&&': {
      backgroundColor: token.colorWhite,
      borderRadius: token.borderRadiusSM,
      boxShadow: INPUT_BOX_SHADOW,
      height: INPUT_BASE_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
      cursor: 'text',
      paddingLeft: ThemeSpaces.SPACE_NORM_20,
      gap: ThemeSpaces.SPACE_SM,
      fontSize: 32,
      fontFamily: "'League Gothic'",
      color: ThemeColors.COLOR_GREY7_6,
      lineHeight: 1,

      '&.has-value': {
        color: ThemeColors.COLOR_RED,
      },
    },
  },
  calendarPopup: {
    position: 'relative',
    width: '100%',

    '> *': {
      width: '100%',
    },
  },
  dateInput: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    font: 'inherit',
    color: 'inherit',
    width: '100%',
    padding: 0,

    '&::placeholder': {
      color: ThemeColors.COLOR_GREY7_6,
    },
  },
  calendarContainer: {
    position: 'absolute',
    top: `calc(100% + ${ThemeSpaces.SPACE_NORM}px)`,
    left: 0,
    right: 0,

    '.ant-picker-calendar .ant-picker-panel .ant-picker-date-panel': {
      width: 264,
    },
  },
  envelope: {
    backgroundColor: ThemeColors.COLOR_WHITE2,
    borderRadius: token.borderRadius,
    border: `1px solid ${ThemeColors.COLOR_WHITE}`,
    boxShadow: `0 2px 20px ${ThemeColors.COLOR_GREY_BLUISH3}`,
    padding: ThemeSpaces.SPACE_NORM,

    '.ant-btn.ant-btn-default:hover': {
      borderColor: `${ThemeColors.COLOR_RED} !important`,
    },

    '&.with-custom-selectors': {
      boxShadow: `0 0 0 1px ${ThemeColors.COLOR_WHITE}, 0 2px 20px ${ThemeColors.COLOR_GREY_BLUISH3}`,
      padding: ThemeSpaces.SPACE_NORM_20,
    },
  },
  calendar: {
    '&.ant-picker-calendar': {
      backgroundColor: 'transparent',

      '.ant-picker-panel': {
        backgroundColor: 'transparent',
      },

      '.ant-picker-content': {
        height: 220,
      },

      '.ant-picker-body': {
        padding: 0,

        'thead > tr': {
          height: 26,
          borderTop: `1px solid ${ThemeColors.COLOR_GREY7}`,
          borderBottom: `1px solid ${ThemeColors.COLOR_GREY7}`,

          th: {
            lineHeight: '26px',
            fontWeight: 'bold',
            fontSize: token.fontSizeSM,
            color: ThemeColors.COLOR_GREY_BLUISH7_2,
            textTransform: 'uppercase',
          },
        },

        'tbody > tr': {
          '&:first-child': {
            paddingTop: ThemeSpaces.SPACE_XS,
          },

          td: {
            fontWeight: 500,
            fontSize: token.fontSizeLG,
          },

          '.ant-picker-cell': {
            padding: 0,
            color: ThemeColors.COLOR_GREY7_4,

            '.ant-picker-cell-inner': {
              width: 32,
              height: 32,
              lineHeight: '32px',
            },
          },

          '.ant-picker-cell-in-view': {
            color: ThemeColors.COLOR_GREY_BLUISH2,
          },

          '.ant-picker-calendar-date-value': {
            display: 'none',
          },
        },
      },
    },
  },
  calendarMonthSelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: `${ThemeSpaces.SPACE_XXS}px 0 ${ThemeSpaces.SPACE_XS}px 0`,

    '.ant-select': {
      fontSize: token.fontSizeLG,
      fontWeight: 500,
      color: ThemeColors.COLOR_GREY_DARK5,

      '.ant-select-selector': {
        padding: `0 ${ThemeSpaces.SPACE_SM}px !important`,
      },

      '.ant-select-arrow': {
        color: ThemeColors.COLOR_GREY6,
      },
    },
    '&&& .ant-select .ant-select-selector': {
      '&::after': {
        content: 'none',
      },
    },
  },
  selector: {
    width: '100% !important',
    height: '28px !important',
    color: ThemeColors.COLOR_GREY6,
    textAlign: 'center',
    fontWeight: 600,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,

    '.ant-select-selector': {
      color: ThemeColors.COLOR_GREY6,
      textAlign: 'center',
      width: '100% !important',
      height: '28px !important',
      border: `0.5px solid ${ThemeColors.COLOR_GREY6}`,
      borderRadius: 4,
      backgroundColor: ThemeColors.COLOR_GREY9_5,

      '.ant-select-selection-item, .ant-select-selection-placeholder': {
        height: '26px !important',
        fontSize: '14px !important',
        fontWeight: 500,
        color: `${ThemeColors.COLOR_GREY4} !important`,
      },

      '.ant-select-selection-search input': {
        lineHeight: '26px !important',
        fontSize: `${token.fontSizeSM}px !important`,
      },
    },

    '&.ant-select-focused .ant-select-selector': {
      borderColor: `${ThemeColors.COLOR_GREY6} !important`,
      boxShadow: '0 0 0 1px rgba(133, 146, 169, 0.3) !important',
    },

    '.ant-select-arrow': {
      color: ThemeColors.COLOR_GREY3,
      fontWeight: 900,
      fontSize: token.fontSizeSM,
    },
  },
}));
